import texts from './texts';

const formatMacro = (value) => (
  value === null || value === undefined ? '—' : Math.round(value)
);

const macroPillText = (label, value) => (
  `${label} ${formatMacro(value)}g ${texts.autocomplete.per100gSuffix}`
);

export {
  formatMacro,
  macroPillText,
};
